import React from 'react'
import { OtpInput } from 'react-native-otp-entry'

import {
  containerStyles,
  getFocusStickStyles,
  getInputContainerStyles,
  getInputStyles,
  selectionColor,
} from './styles'
import type { NativeProps } from './types'

const DEFAULT_NUMBER_OF_INPUTS = 4

const CodeInput = (props: NativeProps) => {
  return (
    <OtpInput
      ref={props.otpRef}
      numberOfDigits={props.numberOfDigits || DEFAULT_NUMBER_OF_INPUTS}
      autoFocus
      secureTextEntry={props.isSecure}
      theme={{
        pinCodeTextStyle: getInputStyles(props.codeStatus, Boolean(props.isSecure)),
        pinCodeContainerStyle: getInputContainerStyles(props.codeStatus),
        containerStyle: containerStyles,
        focusStickStyle: getFocusStickStyles(props.codeStatus),
      }}
      focusColor={selectionColor}
      onTextChange={props.handleChange}
      textInputProps={{
        testID: props.testID,
        ...props.textInputProps,
        keyboardType: props.textInputProps?.keyboardType ?? 'phone-pad',
      }}
    />
  )
}

export default CodeInput
